const AdleakRoutes = {
  getAllAdleaks: "/admin/getallblogs",
  createAdLeaks: "/blog/blog",
  updateAdLeaks: "/blog/updateblogs",
  approveBlog: "/admin/approveBlog",
  deleteBlog: "/blog/deleteblogs"
}

export default AdleakRoutes;